import { computed, defineComponent, h } from 'vue';
import BarButton from '@components/bar-button';
import { coming_soon } from '@components/icons';
import { img } from '@phi/components';
import { show_settings_modal } from '@features/user-settings/state';
import settings_svg from '../../../../../frontend/phi3d/src/assets/img/SVG_icons/Top/search/settings.svg';
import SettingsTooltip from './SettingsTooltip';

export const SettingsButton = defineComponent({
    props: {
        loaded: { required: true, type: Boolean },
        tut_stage: { required: true, type: Number },
    },

    setup(props) {
        const is_coming_soon = computed(() => !props.loaded);
        const disabled = computed(() => !props.loaded);
        const selected = computed(() => props.tut_stage === 14 || props.tut_stage === 8);
        const alt = 'Settings';

        return () => h(BarButton, {
            id: 'settings-button',
            wrapperId: 'settings-wrapper',
            active: false,
            disabled: disabled.value,
            selected: selected.value,
            onClick: show_settings_modal,
            tippy: 'left',
        }, {
            label: () => 'Settings',
            icon: () => is_coming_soon.value ? coming_soon(alt) : img(settings_svg, alt),
            tooltip: SettingsTooltip,
        });
    },
});
